import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceTinUpdateRequestQueueContainerModel } from '../../../../../models/aggregates/e-invoice/my_einvoice_tin_update_request_queue_container.model';
import { Observable } from 'rxjs';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { EntityContainerModel } from '../../../../../models/aggregates/erp/entity/entity-container.model';

@Injectable({
  providedIn: 'root'
})
export class MyEInvoiceTinUpdateRequestQueueService extends BaseApiTemplateService<MyEInvoiceTinUpdateRequestQueueContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-queues/backoffice-ep'
    this.httpClient = http;
  }

  updateUserTin(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<EntityContainerModel>> {
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-queues/email-response/update-tin/public-ep';
    let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-queues/email-response/update-tin/public-ep';
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<EntityContainerModel>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
